import { request } from "@/interface/helper";

const str = "nftStation";

export const nftStation = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/nft/station/list" }),
    add: (data) => request({ data, method: "post", url: "/nft/station/add" }),
    detail: (data) => request({ data, method: "post", url: "/nft/station/detail" }),
    edit: (data) => request({ data, method: "post", url: "/nft/station/modify" }),
    clearRule: (data) => request({ data, method: "post", url: "/nft/station/clear" }),
  },
};
